var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { call, put, takeLatest } from "redux-saga/effects";
import { FETCH_WHATSAPP_NDR_VERIFICATION_CHARGES_REQUEST, fetchWhatsappNdrVerificationChargesFailure, fetchWhatsappNdrVerificationChargesSuccess, } from "../../actions";
import APIIN from "../../../utils/APIIN";
const onfetchWhatsappNdrVerificationCharges = (action) => __awaiter(void 0, void 0, void 0, function* () {
    return yield new Promise((resolve, reject) => __awaiter(void 0, void 0, void 0, function* () {
        try {
            APIIN.get(`rms/admin/vas/rate?tenantId=${action.payload.tenantId}&vasService=${action.payload.vasService}&countryCode=${action.payload.countryCode}`)
                .then((data) => {
                resolve(data);
            })
                .catch((error) => {
                reject(error);
            });
        }
        catch (error) {
            if (error instanceof Error) {
                reject(error);
            }
        }
    }));
});
function* getWhatsappNdrVerificationChargesWorker(action) {
    try {
        const data = yield call(onfetchWhatsappNdrVerificationCharges, action);
        yield put(fetchWhatsappNdrVerificationChargesSuccess(data));
    }
    catch (error) {
        yield put(fetchWhatsappNdrVerificationChargesFailure(error));
    }
}
export function* watchGetWhatsappNdrVerificationChargesData() {
    yield takeLatest(FETCH_WHATSAPP_NDR_VERIFICATION_CHARGES_REQUEST, getWhatsappNdrVerificationChargesWorker);
}
